// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__3AAxe","inner":"style_inner__128xy","bottom":"style_bottom__3vyMo","copyright":"style_copyright__26eAZ"};